import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { Spinner } from "@/components/common";
import Apply from "@/pages/public/Apply";
import ApplyPrivacy from "@/pages/public/ApplyPrivacy";
import JobPage from "@/pages/public/JobPage";
import Jobs from "@/pages/public/Jobs";
import Refer from "@/pages/public/Refer";

/** The whole logged-in application is a separate chunk, loaded only once somebody asks for a page
 *  inside it. `/apply` is read on a cheap phone on slow data: it must not download the HR
 *  Command Center to show a form, and it must not mount `AuthProvider` — no session call, no
 *  cookie, no app shell. */
const AuthedApp = lazy(() => import("@/AuthedApp"));

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/privacy" element={<ApplyPrivacy />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:slug" element={<JobPage />} />
          <Route path="/refer" element={<Refer />} />
          <Route
            path="*"
            element={
              <Suspense fallback={
                <div className="grid min-h-screen place-items-center" data-testid="app-loading">
                  <Spinner className="h-6 w-6 text-primary" />
                </div>
              }>
                <AuthedApp />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
